import { useMutation } from "react-query";
import request from "@common/request";

const useSendHouseholdInvitation = () =>
  useMutation("sendInvitation", (emails: string[] | string) =>
    request("POST", "/api/me/household-invites", {
      emails: emails.toString(),
    })
  );

export { useSendHouseholdInvitation };
